import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { get_single_holidays } from '../api/holidaysApi';
import { formatDateWithoutTime } from '../../../helper-functions/DateFunction';
import { formatDynamicDateTime } from '../../../helper-functions/DateFunction';
import { useGeneralSettings } from '../../../contexts/GeneralSettingsContext';
function ViewHoliday() {
  const { getSettingValue } = useGeneralSettings();
  const userDateFormat = getSettingValue('date_format') || 'dd-mm-yyyy';
  const userTimeFormat = getSettingValue('time_format') || '12hr';
  const userTimeZone = getSettingValue('time_zone') || 'UTC';
  

    const [selectedHoliday, setSelectedHoliday] = useState<any | null>();
    const location = useLocation();
    const id = (location.state as { id: number }).id;
    const { data: viewHoliday, isLoading: viewHolidayIsLoading, error: viewHolidayIsError } = useQuery(['ViewHoliday',id,{ refetchOnWindowFocus: false }], () =>
        get_single_holidays(id)
    );
    useEffect(() => {
        if (viewHoliday) {
            setSelectedHoliday(viewHoliday.data);
        }
    }, [viewHoliday]);
    const navigate = useNavigate();
    if (viewHolidayIsLoading) {
        return (
            <div className='text-center'>
                <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                </div>
            </div>
        );
    }
    if (viewHolidayIsError) {
        return (
            <div className='text-center'>
                <h2>Error in Get All Holidays</h2>
            </div>
        );
    }
    return (
        <div className='card mb-5 mb-xl-10'>
            <div
                className='card-header border-0'
                data-bs-toggle='collapse'
                data-bs-target='#kt_account_profile_details'
                aria-expanded='true'
                aria-controls='kt_account_profile_details'
            >
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bolder fs-3 mb-1'>View Holiday</span>
                </h3>
                <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                >
                    <button
                        data-toggle="tooltip" data-placement="bottom" title="Navigate to List holiday Type"
                        className='btn btn-sm btn-light-dark fs-5'
                        onClick={() => navigate('/holidays/list')}
                    >
                        List of holidays
                    </button>
                </div>
            </div>
            <div id='kt_account_profile_details' className='collapse show'>
                <div className='card-body border-top p-9'>
                    {selectedHoliday && (
                        <>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>Holiday</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <div className='form-control form-control-lg form-control-solid'>{selectedHoliday.title}</div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>From Date</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <div className='form-control form-control-lg form-control-solid'>{formatDynamicDateTime(selectedHoliday.from_date, userDateFormat, userTimeFormat, userTimeZone)}</div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span className='required'>To Date</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <div className='form-control form-control-lg form-control-solid'>{formatDynamicDateTime(selectedHoliday.to_date, userDateFormat, userTimeFormat, userTimeZone)}</div>
                                </div>
                            </div>
                            <div className='row mb-6'>
                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                    <span>Description</span>
                                </label>
                                <div className='col-lg-8 fv-row'>
                                    <div className='form-control form-control-lg form-control-solid'>{selectedHoliday.description?selectedHoliday.description:"No Description"}</div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
export default ViewHoliday;
